import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { config } from "../../shared/environment";
import { RevenueReportResponse } from "../../components/dashboard/revenueReport/revenueReport.module";

interface initialState {
    getAllRevenueReport: { loading: boolean, value: RevenueReportResponse | null, error: string, isReached: boolean, filter: string | null }
}

const initialState: initialState = {
    getAllRevenueReport: { error: '', loading: false, value: null, isReached: false, filter: null }
}

export const getAllRevenueReport = createAsyncThunk('report/revenueReport', ({ data }: { data: { offset: number, limit: number, filterData: string } }) => {
    let Url = HttpRoutingService.replaceUrl(API.RevenueReport, { storeId: config.storeId })
    return HttpRoutingService.getMethod<RevenueReportResponse>(Url, data)
})

export const RevenueReportSlice = createSlice({
    initialState,
    name: 'revenueReport',
    reducers: {},
    extraReducers(builder) {
        builder.addCase(getAllRevenueReport?.pending, (state) => {
            state.getAllRevenueReport.loading = true
        })
        builder.addCase(getAllRevenueReport?.fulfilled, (state, action) => {
            state.getAllRevenueReport.loading = false
            let prev = state.getAllRevenueReport.value
            let current = action?.payload
            let offset = action?.meta?.arg?.data?.offset
            let combine: RevenueReportResponse | null = null

            if (offset > 0 && prev?.revenueReport?.revenueData) {
                const existingMap = new Set(
                    prev.revenueReport.revenueData.map(item => item.orderDate)
                );
                const newItems = (current?.revenueReport?.revenueData || []).filter(
                    item => !existingMap.has(item.orderDate)
                );

                combine = {
                    message: current?.message ?? prev?.message ?? "",
                    statusCode: current?.statusCode ?? prev?.statusCode ?? "",
                    success: current?.success ?? prev?.success ?? false,
                    revenueReport: {
                        ...prev.revenueReport,
                        ...current?.revenueReport,
                        revenueData: [...prev.revenueReport.revenueData, ...newItems],
                    }
                }
            } else {
                combine = current
            }

            if (current?.revenueReport?.revenueData?.length < action.meta.arg.data.limit) {
                state.getAllRevenueReport.isReached = true
            } else {
                state.getAllRevenueReport.isReached = false
            }

            state.getAllRevenueReport.value = combine
            state.getAllRevenueReport.filter = action.meta.arg.data.filterData
        })
        builder.addCase(getAllRevenueReport?.rejected, (state, action) => {
            state.getAllRevenueReport.loading = false
            state.getAllRevenueReport.error = action?.error?.message ? action?.error?.message : 'Error in getAllRevenueReport'
        })
    },
})


export default RevenueReportSlice?.reducer